import apiClient from './apiClient';

export const paymentsApi = {
	// Create a payment intent
	createPaymentIntent: async (data) => {
		try {
			const response = await apiClient.post(
				`/api/payments/create-payment-intent`,
				data
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message ||
					'Failed to create payment intent'
			);
		}
	},

	// Get all available products from Stripe
	getProducts: async () => {
		try {
			const response = await apiClient.get('/api/payments/products');
			return response.data.products;
		} catch (error) {
			console.error('Error fetching products:', error);
			throw new Error(
				error.response?.data?.message ||
					'Failed to fetch available products'
			);
		}
	},

	// Create a checkout session
	createCheckoutSession: async (organizationId, data) => {
		try {
			// Format the request exactly as the backend expects it
			const requestData = {
				priceId: data.items[0].priceId, // Use the first item's ID
				productName: data.items[0].name || 'Storage Add-on', // Use the item name or default
				organizationId: organizationId,
				successUrl: `${window.location.origin}/dashboard/subscription?success=true&organizationId=${organizationId}`,
				cancelUrl: `${window.location.origin}/dashboard/subscription`,
			};

			// Call the API with the reformatted data
			const response = await apiClient.post(
				`/api/payments/create-checkout-from-product`,
				requestData
			);

			return response.data;
		} catch (error) {
			console.error('Error creating checkout session:', error);
			throw new Error(
				error.response?.data?.message ||
					'Failed to create checkout session'
			);
		}
	},

	// Get payment history
	getPaymentHistory: async (organizationId) => {
		try {
			const response = await apiClient.get(
				`/api/payments/history/${organizationId}`
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message ||
					'Failed to fetch payment history'
			);
		}
	},

	// Get invoice details
	getInvoice: async (invoiceId) => {
		try {
			const response = await apiClient.get(
				`/api/payments/invoice/${invoiceId}`
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to fetch invoice'
			);
		}
	},
};
